import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { FunctionComponent } from 'react';
import HeaderTableColumn from './HeaderTableColumn';
import { bookedAtSorter, clientSorter, petSorter, serviceSorter, statusSorter, totalSorter } from './sorting';
import { Sorter } from '@spike/appointments-list-model';

interface EvaluationHeaderTableProps {
    sorter: Sorter | null;
    onSort?: (sorter: Sorter) => void;
}

export const EvaluationHeaderTable: FunctionComponent<EvaluationHeaderTableProps> = props => {
    return (
        <TableHeader>
            <HeaderTableColumn
                columnSorter={clientSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Client Name
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={petSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Pet Name
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={serviceSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Service
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={bookedAtSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Date & Time
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={totalSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Total
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={statusSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Status
            </HeaderTableColumn>
        </TableHeader>
    );
};

export default EvaluationHeaderTable;
